import { getErrorJson } from '@mm/utils';

export const update = () => (error: Response) => {
  if (error.status === 422) {
    return getErrorJson(error);
  }

  throw error;
};
